import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function removeTagFromMilestone(httpClient: HttpClient) {
  return (tag: Tag, milestoneId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/milestones/${milestoneId}`,
        method: HttpMethods.GET,
      })
      .then((milestone) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/milestones/${milestoneId}`,
          method: HttpMethods.PATCH,
          data: {
            // @ts-ignore
            tags: milestone.tags.filter((name) => name !== tag.name),
          },
        }),
      );
}

export { removeTagFromMilestone };
